<template>
  <div class="hello">
    <h1>你一定很想知道之前的議程，所以才會進來看吧！</h1>

    <div>第{{ param }}次的議程：</div>
    <div v-if="!loading">
      <ul>
        <li class="block">{{ allConf.vincent[param - 1] }}｜ Vincent</li>
        <li class="block">{{ allConf.chris[param - 1] }} ｜ Chris</li>
        <li class="block">{{ allConf.jing[param - 1] }} ｜ Jing</li>
      </ul>

      <div>
        <div>
          <span style="margin-right: 4px">Back to </span>
          <router-link :to="{ name: 'Home' }">
            <strong>Home</strong>
          </router-link>
        </div>
        <div>
          <span style="margin-right: 4px">Jump to the</span>
          <router-link :to="{ name: 'Conf', params: { confId: param - 1 } }">
            <strong>Prev</strong>
          </router-link>
          <span style="margin-right: 4px">, or the</span>
          <router-link :to="{ name: 'Conf', params: { confId: param + 1 } }">
            <strong>Next</strong>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Conf",
  data() {
    return {
      allConf: {},
      param: 999,
      loading: true,
    };
  },
  created() {
    this.param = this.$route.params.confId;
    // console.log("param", param);

    axios
      .get(
        "https://script.google.com/macros/s/AKfycbzsWcSBu05V1gYHhggaKCLT0h6n6zVjGTWh-l8KJPYSJcfo0yEVPukhb6bfTr6pHy2R/exec"
      )
      // .then((response) => (this.conf = response.data));
      .then((response) => {
        this.allConf = response.data;
        console.log(response.data);
        this.loading = false;
      });
  },
  watch: {
    "$route.params.confId"() {
      this.param = this.$route.params.confId;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.block {
  display: block;
}
</style>
